import { render } from "./ChipInput.vue?vue&type=template&id=24d48243"
import script from "./ChipInput.vue?vue&type=script&lang=js"
export * from "./ChipInput.vue?vue&type=script&lang=js"

import "./ChipInput.vue?vue&type=style&index=0&id=24d48243&lang=scss"
script.render = render

export default script